import Breadcrumb from "components/Common/Breadcrumb2"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import { withTranslation } from "react-i18next"
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"

import toast from "components/Toast/Toast"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import Select from "react-select"
import {
  createProduct,
  deleteProduct,
  getAllProducts,
  restoreProduct,
  updateProduct,
} from "services/products/calls"
// import { brands } from "./constants"

const Produtos = props => {
  document.title = "Cadastro de Produtos | Sensetek"
  moment.locale("pt-br")
  const { t } = props

  const [isLoading, setIsLoading] = useState(true)
  const [produtos, setProdutos] = useState()
  const [produtosList, setProdutosList] = useState([])
  const [novoProduto, setNovoProduto] = useState({
    name: "",
    tag: "",
    // brand: null,
    code: "",
  })
  const [updatedProduct, setUpdatedProduct] = useState({
    name: "",
    tag: "",
    // brand: null,
    code: "",
  })

  const [confirm, setConfirm] = useState({})
  const [showConfirm, setShowConfirm] = useState(false)
  const [modalUpdateProduct, setModalUpdateProduct] = useState(false)

  const selectRow = {
    mode: "checkbox",
    hideSelectColumn: true,
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  const initPageOptions = {
    sizePerPage: 20,
    totalSize: 0,
    custom: true,
    showTotal: true,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    prePageText: "Anterior",
    nextPageText: "Próximo",
    paginationTotalRenderer: (from, to, size) => {
      return (
        <div className="d-inline">
          <span className="react-bootstrap-table-pagination-total">
            Registros Retornados: {size}
          </span>
        </div>
      )
    },
  }

  const [pageOptions, setPageOptions] = useState(initPageOptions)

  const columns = [
    {
      dataField: "id",
      text: "#",
      sort: false,
      headerStyle: {
        width: "50px",
      },
      formatter: (cellContent, row) => <b>{cellContent}</b>,
    },
    {
      dataField: "name",
      text: "Produto",
      sort: false,
    },
    {
      dataField: "tag",
      text: "Nome do Produto",
      sort: false,
    },
    {
      dataField: "code",
      text: "Código",
      sort: false,
    },
    {
      dataField: "deletedAt",
      isDummyField: true,
      text: "Situação",
      sort: false,
      searchable: false,
      headerAlign: "center",
      align: "center",
      filterValue: (cell, row) => (row.deletedAt ? "Inativado" : "Ativo"),
      formatter: (cellContent, row) =>
        row.deletedAt ? (
          <Badge color="warning" className="badge-warning me-1">
            <b>Inativado</b>
          </Badge>
        ) : (
          <Badge className="badge-primary me-1">
            <b>Ativo</b>
          </Badge>
        ),
    },
    {
      dataField: "actions",
      isDummyField: true,
      text: "Ações",
      headerAlign: "center",
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { width: "10%", textAlign: "center" }
      },
      formatter: (cellContent, row) => (
        <ul className="list-unstyled hstack gap-1 mb-0 justify-content-center">
          <li>
            <a
              target="_blank"
              className={`btn btn-sm btn-primary`}
              onClick={() => {
                setUpdatedProduct({
                  ...row,
                  // brand: brands?.filter(s => s.value === row.brand)[0],
                })
                setModalUpdateProduct(true)
              }}
            >
              <i
                className="mdi mdi-account-edit"
                id={`altToolTip${row.id}`}
              ></i>
            </a>
            <UncontrolledTooltip placement="top" target={`altToolTip${row.id}`}>
              Alterar
            </UncontrolledTooltip>
          </li>
          <li>
            <a
              target="_blank"
              className={`btn btn-sm btn-${
                row.deletedAt ? "secondary" : "danger"
              }`}
              onClick={async () => {
                if (row.deletedAt) {
                  try {
                    setIsLoading(true)
                    await restoreProduct(row.id)
                    fetchProdutos()
                    toast("success", "Produto ativado com sucesso!")
                  } catch (error) {
                    toast("warning", "Falha ao ativar Produto.")
                    console.log(error)
                  } finally {
                    setIsLoading(false)
                  }
                } else {
                  setConfirm({
                    title: "Confirmação",
                    body: (
                      <div>
                        <p>Esta ação ira desabilitar esta opção de Produto.</p>
                        <p>
                          Por favor, confirme se tem certeza que deseja
                          desabilitar este Produto?
                        </p>
                      </div>
                    ),
                    onConfirm: async () => {
                      setIsLoading(true)
                      try {
                        await deleteProduct(row.id)
                        fetchProdutos()
                        toast("success", "Produto desativado com sucesso!")
                      } catch (error) {
                        toast("warning", "Falha ao desativar Produto.")
                        console.log(error)
                      } finally {
                        setIsLoading(false)
                      }
                    },
                  })
                  setShowConfirm(true)
                }
              }}
            >
              <i
                className={`mdi mdi-${
                  row.deletedAt ? "account-reactivate" : "delete-forever"
                }`}
                id={`delToolTip${row.id}`}
              ></i>
            </a>
            <UncontrolledTooltip placement="top" target={`delToolTip${row.id}`}>
              {`${row.deletedAt ? "Reativar" : "Desativar"}`}
            </UncontrolledTooltip>
          </li>
        </ul>
      ),
    },
  ]

  const fetchProdutos = async () => {
    try {
      setIsLoading(true)
      const products = await getAllProducts()
      setPageOptions(old => {
        return { ...old, totalSize: products?.length }
      })
      setProdutos(products)
      setProdutosList(products)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    try {
      fetchProdutos()
    } catch (error) {
      console.error(error)
    }
  }, [])

  const validarNovoProduto = values => {
    let errors = []
    if (values?.name === "") {
      errors.push("Não é possível inserir um produto sem nome.")
    }
    if (values?.tag === "") {
      errors.push("Não é possível inserir um produto sem tag.")
    }
    if (values?.code === "") {
      errors.push("Não é possível inserir um produto sem nome.")
    }
    // if (values?.brand === null) {
    //   errors.push("Não é possível inserir um produto sem brand.")
    // }
    if (errors?.length > 0) {
      return errors
    } else {
      return null
    }
  }

  const validarAlterarProduto = values => {
    let errors = []
    if (values?.name === "") {
      errors.push("Não é possível alterar um produto para sem nome.")
    }
    if (values?.tag === "") {
      errors.push("Não é possível alterar um produto para sem tag.")
    }
    if (values?.code === "") {
      errors.push("Não é possível alterar um produto para sem nome.")
    }
    // if (values?.brand === null) {
    //   errors.push("Não é possível alterar um produto para sem brand.")
    // }
    if (errors?.length > 0) {
      return errors
    } else {
      return null
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setIsLoading(true)
    try {
      const errors = validarNovoProduto(novoProduto)
      if (errors) {
        toast("warning", errors.join("<br />"))
      } else {
        try {
          await createProduct({
            ...novoProduto,
            // brand: novoProduto?.brand?.value,
          })
          setNovoProduto({
            name: "",
            tag: "",
            // brand: null,
            code: "",
          })
          fetchProdutos()
          setModalUpdateProduct(false)
          toast("success", "Produto adicionado com sucesso!")
        } catch (error) {
          console.error(error)
          toast("error", "Falha ao adicionar Produto")
        }
      }
    } catch (error) {
      toast("warning", "Falha ao criar produto.")
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleUpdateStatus = async e => {
    e.preventDefault()
    try {
      const errors = validarAlterarProduto(updatedProduct)
      if (errors) {
        toast("warning", errors.join("<br />"))
      } else {
        try {
          await updateProduct(updatedProduct.id, {
            ...updatedProduct,
            // brand: updatedProduct?.brand?.value,
          })
          setUpdatedProduct({
            name: "",
            tag: "",
            // brand: null,
            code: "",
          })
          fetchProdutos()
          toast("success", "Produto atualizado com sucesso!")
        } catch (error) {
          console.error(error)
          toast("error", "Falha ao atualizar Produto")
        }
      }
    } catch (error) {
      toast("warning", "Falha ao atualizar produto.")
      console.log(error)
    } finally {
      setModalUpdateProduct(false)
      setIsLoading(false)
    }
  }

  const CustomSearch = props => {
    return (
      <div>
        <Input
          className="form-control"
          type="text"
          placeholder="Pesquisar"
          value={props.searchText}
          onChange={e => {
            props.onSearch(e.target.value)
          }}
        />
      </div>
    )
  }

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Configurações")}
            breadcrumbItems={[{ title: props.t("Produtos"), path: "#" }]}
          />
          <Row>
            <Col>
              <Card className="mb-0 border-bottom">
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  {t("Adicionar")}
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col sm={2}>
                        <FormGroup>
                          <Label>{t("Produto")}</Label>
                          <Input
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder="Nome"
                            disabled={isLoading}
                            value={novoProduto.name}
                            onChange={e => {
                              setNovoProduto(old => {
                                return { ...old, name: e.target.value }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={4}>
                        <FormGroup>
                          <Label>{t("Nome do Produto")}</Label>
                          <Input
                            name="tag"
                            type="text"
                            className="form-control"
                            placeholder="Tag"
                            disabled={isLoading}
                            value={novoProduto.tag}
                            onChange={e => {
                              setNovoProduto(old => {
                                return { ...old, tag: e.target.value }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      {/* <Col sm={2}>
                        <FormGroup>
                          <Label>Brand</Label>
                          <Select
                            classNamePrefix="reactSelect"
                            options={brands}
                            placeholder="Brand"
                            name="brand"
                            menuPortalTarget={document.body}
                            value={novoProduto.brand}
                            onChange={e => {
                              setNovoProduto(old => {
                                return { ...old, brand: e }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col> */}
                      <Col sm={2}>
                        <FormGroup>
                          <Label>{t("Código")}</Label>
                          <Input
                            name="code"
                            type="text"
                            className="form-control"
                            placeholder="Código"
                            disabled={isLoading}
                            value={novoProduto.code}
                            onChange={e => {
                              setNovoProduto(old => {
                                return { ...old, code: e.target.value }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col className="d-flex align-items-end">
                        <FormGroup>
                          <Button type="submit">{t("Adicionar")}</Button>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  Lista de Produtos
                </CardHeader>
                <CardBody>
                  {isLoading ? (
                    <div
                      className="accordion-body"
                      style={{ textAlign: "center" }}
                    >
                      <Spinner className="ms-2" color="primary" />
                    </div>
                  ) : produtosList?.length > 0 ? (
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="eventId"
                      columns={columns}
                      data={produtosList}
                    >
                      {({ paginationTableProps, paginationProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={columns}
                          columnToggle
                          data={produtosList}
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <Row>
                                <Col sm={10}>
                                  <CustomSearch
                                    {...toolkitProps.searchProps}
                                    placeholder="Pesquisar"
                                  />
                                </Col>
                                <Col lg={2}>
                                  <FormGroup>
                                    <Select
                                      classNamePrefix="reactSelect"
                                      options={[
                                        { label: "Ativo", value: "A" },
                                        { label: "Inativo", value: "B" },
                                      ]}
                                      placeholder="Situação"
                                      isDisabled={isLoading}
                                      isClearable
                                      onChange={e => {
                                        if (e == null) {
                                          setProdutosList(produtos)
                                        } else {
                                          if (e?.value == "A") {
                                            setProdutosList(
                                              produtos.filter(
                                                p => p.deletedAt == null
                                              )
                                            )
                                          } else {
                                            setProdutosList(
                                              produtos.filter(
                                                p => p.deletedAt != null
                                              )
                                            )
                                          }
                                        }
                                        return e
                                      }}
                                      menuPortalTarget={document.body}
                                    />
                                  </FormGroup>
                                </Col>
                                <hr />
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <BootstrapTable
                                    keyField={"id"}
                                    bordered={true}
                                    striped={true}
                                    condensed
                                    defaultSorted={defaultSorted}
                                    selectRow={selectRow}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                              <PaginationListStandalone {...paginationProps} />
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  ) : (
                    <div style={{ textAlign: "center" }}>
                      <h5>Nenhum dado foi encontrado.</h5>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={showConfirm}
        toggle={() => {
          setShowConfirm(!showConfirm)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>{confirm?.title}</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              {
                confirm
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{confirm?.body}</div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {t("Cancelar")}
          </button>
          <button
            type="button"
            onClick={async () => {
              await confirm?.onConfirm()
              setShowConfirm(false)
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {t("Confirmar")}
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={modalUpdateProduct}
        toggle={() => {
          setModalUpdateProduct(!modalUpdateProduct)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>Atualizar Produto</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setModalUpdateProduct(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleUpdateStatus} id="updateProduct">
            <Row>
              <Col>
                <Label>{t("Novo Nome")}</Label>
                <Input
                  type="text"
                  className="form-control"
                  disabled={isLoading}
                  value={updatedProduct.name}
                  onChange={e => {
                    setUpdatedProduct(old => {
                      return { ...old, name: e.target.value }
                    })
                  }}
                />
              </Col>
              <Col>
                <Label>{t("Novo Código")}</Label>
                <Input
                  type="text"
                  className="form-control"
                  disabled={isLoading}
                  value={updatedProduct.code}
                  onChange={e => {
                    setUpdatedProduct(old => {
                      return { ...old, code: e.target.value }
                    })
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <Label>{t("Nova Tag")}</Label>
                <Input
                  type="text"
                  className="form-control"
                  disabled={isLoading}
                  value={updatedProduct.tag}
                  onChange={e => {
                    setUpdatedProduct(old => {
                      return { ...old, tag: e.target.value }
                    })
                  }}
                />
              </Col>
            </Row>
            <br />
            {/* <Row>
              <Col>
                <Label>Brand</Label>
                <Select
                  classNamePrefix="reactSelect"
                  options={brands}
                  placeholder="Status Safra"
                  value={updatedProduct.brand}
                  onChange={e => {
                    setUpdatedProduct(old => {
                      return { ...old, brand: e }
                    })
                  }}
                />
              </Col>
            </Row> */}
          </Form>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setModalUpdateProduct(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {t("Cancelar")}
          </button>
          <button
            type="submit"
            form="updateProduct"
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {t("Confirmar")}
          </button>
        </div>
      </Modal>
    </>
  )
}

Produtos.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Produtos)
